import { styled } from 'baseui'

export const OuterContainer = styled('div', ({ $theme }) => ({
  padding: '1rem',
  marginBottom: '2rem',
  color: $theme.colors.white,
}))

export const ComparatorFieldRow = styled('div', () => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.5rem',
  width: '100%',
  '> div:first-of-type': {
    flexGrow: 1,
  },
}))

export const ComparatorRefreshNote = styled('span', ({ $theme, $failed }) => ({
  color: $failed ? $theme.colors.negative : $theme.colors.contentSecondary,
}))

export const Block = styled('div', ({ $theme }) => ({
  padding: '1rem',
  marginTop: '2rem',
  marginBottom: '2rem',
  backgroundColor: $theme.colors.white,
  borderRadius: '1rem',
  boxShadow: $theme.lighting.shadowPrimary,
  width: '100%',
  color: $theme.colors.contentSecondary,
}))
